<!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
<script setup>
defineProps({
  label: { type: String, default: '' },
  icon: { type: String, default: '' },
  disabled: { type: Boolean, default: false },
  tone: { type: String, default: 'default' },
  mobileSidebarSafe: { type: Boolean, default: false },
});

const emit = defineEmits(['click']);
</script>

<template>
  <button
    type="button"
    class="flex min-h-11 items-center gap-3 rounded-lais border px-4 py-3 text-left text-[14px] font-semibold transition-colors disabled:cursor-not-allowed disabled:opacity-45"
    :class="[
      mobileSidebarSafe ? 'max-sm:ml-16' : '',
      tone === 'danger'
        ? 'border-rose-200 bg-white text-rose-700 hover:border-rose-300 hover:bg-rose-50'
        : 'border-lais-border bg-white text-lais-text hover:border-lais-primary hover:bg-lais-primary-50 hover:text-lais-primary',
    ]"
    :disabled="disabled"
    @click="emit('click')"
  >
    <span
      v-if="icon"
      class="size-5 shrink-0"
      :class="icon"
      aria-hidden="true"
    />
    <span class="min-w-0 leading-snug [overflow-wrap:anywhere]">
      {{ label }}
    </span>
  </button>
</template>
